const CUSTOMER_ADMIN_BASE = "/customer/admin";
const CUSTOMER_ADMIN_USERS = CUSTOMER_ADMIN_BASE + "/users";
const CUSTOMER_ADMIN_ROLES = CUSTOMER_ADMIN_BASE + "/roles";
const CUSTOMER_ADMIN_PERMISSION_GROUPS = CUSTOMER_ADMIN_BASE + "/permission-groups";

/** App-scoped paths: require app slug for roles and permission-groups. */
function getAppScopedRolesPath(appSlug) {
  return CUSTOMER_ADMIN_BASE + "/" + encodeURIComponent(appSlug) + "/roles";
}

function getAppScopedPermissionGroupsPath(appSlug) {
  return CUSTOMER_ADMIN_BASE + "/" + encodeURIComponent(appSlug) + "/permission-groups";
}

const APP_SCOPED_VIEWS = ["roles", "permission-groups"];

/**
 * Parses pathname and returns { view, appSlug }.
 * - view: "users" | "roles" | "permission-groups" | null
 * - appSlug: string | null (only set for roles and permission-groups when path includes app segment)
 */
export function parseAdminPath(pathname) {
  const path = (pathname || "").replace(/\/$/, "") || "/";
  if (!path.includes("/customer/admin/")) return { view: null, appSlug: null };
  const suffix = path.split("/customer/admin/")[1];
  if (!suffix) return { view: null, appSlug: null };
  if (suffix === "users") return { view: "users", appSlug: null };
  const parts = suffix.split("/");
  if (parts.length >= 2) {
    const appSlug = parts[0];
    if (parts[1] === "roles") return { view: "roles", appSlug };
    if (parts[1] === "permission-groups") return { view: "permission-groups", appSlug };
  }
  if (suffix === "roles" || suffix === "permission-groups") {
    return { view: suffix === "roles" ? "roles" : "permission-groups", appSlug: null };
  }
  return { view: null, appSlug: null };
}

export function getAdminViewFromPath(pathname) {
  const { view } = parseAdminPath(pathname);
  return view;
}

export function isAdminPath(pathname) {
  const path = (pathname || "").replace(/\/$/, "") || "/";
  return path.includes("/customer/admin/");
}

/**
 * Builds admin path for a view. For roles and permission-groups, appSlug is required.
 * If appSlug is missing for an app-scoped view, returns path without app (caller should redirect).
 */
export function buildAdminPath(pathname, view, appSlug = null) {
  const base = pathname.includes("/customer/admin/")
    ? pathname.split("/customer/admin/")[0]
    : (pathname || "").replace(/\/$/, "") || "/";
  const baseNorm = base === "/" ? "" : base.replace(/\/$/, "");
  if (view === "users") return baseNorm + CUSTOMER_ADMIN_USERS;
  if (view === "roles") {
    if (appSlug) return baseNorm + getAppScopedRolesPath(appSlug);
    return baseNorm + CUSTOMER_ADMIN_ROLES;
  }
  if (view === "permission-groups") {
    if (appSlug) return baseNorm + getAppScopedPermissionGroupsPath(appSlug);
    return baseNorm + CUSTOMER_ADMIN_PERMISSION_GROUPS;
  }
  return baseNorm || "/";
}

export function isAppScopedView(view) {
  return APP_SCOPED_VIEWS.includes(view);
}
